export function parseFormFields(fields) {
  if (typeof fields.onChange === 'function') return fields.value
  if (Array.isArray(fields))
    return fields.map((field) => parseFormFields(field))
  if (typeof fields === 'object')
    return Object.entries(fields).reduce((acc, curr) => {
      acc[curr[0]] = parseFormFields(curr[1])
      return acc
    }, {})
  return fields
}
